export default class ZoomBlocker {
  constructor(mapboxmap, main) {
    this._ = main;
    this.map = mapboxmap;
    this.map.scrollZoom.enable();

    const { mapSettings } = this._.settings.getSettings();
    this.mapSettings = mapSettings;

    mapboxmap.on("wheel", (event) => {
      if (event.originalEvent.ctrlKey) {
        return;
      }

      if (event.originalEvent.metaKey) {
        return;
      }

      if (event.originalEvent.altKey) {
        return;
      }

      event.preventDefault();
      this.showBlockAlert();
    });

    this.createScrollZoomBlocker();
  }

  showBlockAlert() {
    if (this.msgContainer.style.visibility === "hidden")
      this.msgContainer.style.visibility = "visible";
    this.msgContainer.classList.add("active");

    clearTimeout(this.time);

    this.time = setTimeout(() => {
      this.msgContainer.classList.remove("active");
    }, 200);

    this._.map.events.mouseleave();
    this._.map.events.addRemoveMapEvents({ remove: true });
    setTimeout(() => {
      this._.map.events.addRemoveMapEvents({ add: true });
    }, 2000);
  }

  createScrollZoomBlocker() {
    if (this.map) {
      const div = document.createElement("div");
      div.classList.add("mapboxgl-zoom-blocker");
      this._.el.appendChild(div);
      this.msgContainer = div;

      if (/(Mac|iPad)/i.test(window.navigator.userAgent)) {
        this.msgContainer.textContent = this.mapSettings.msgContainerMac;
      } else {
        this.msgContainer.textContent = this.mapSettings.msgContainerWin;
      }
    }
  }
}
